import * as React from 'react';
import store from 'owa-calendar-modal-store/lib/store/store';
import { lazyHideMeetingDndModal } from 'owa-calendar-modal-actions';
import { MeetingDndDialogContent } from 'owa-calendar-modal-view';
import { Modal } from '@fluentui/react/lib/Modal';

/**
 * Component for rendering the meeting drag/drop confirmation modal
 */
export default function MeetingDndModalRenderer() {
    if (store.meetingDndModalViewState) {
        return (
            <Modal
                isOpen={true}
                onDismiss={lazyHideMeetingDndModal.importAndExecute}
                isBlocking={false}>
                <MeetingDndDialogContent
                    calendarItemUpdates={store.meetingDndModalViewState.calendarItemUpdates}
                    originalItem={store.meetingDndModalViewState.originalEvent}
                    onDismiss={lazyHideMeetingDndModal.importAndExecute}
                />
            </Modal>
        );
    } else {
        return null;
    }
}
